// extracted by mini-css-extract-plugin
module.exports = {"gyTextarea":"TextArea_gyTextarea__1-mDo","nonResizeable":"TextArea_nonResizeable__3jLhI"};